var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      this.value.data
        ? _c(
            "el-button",
            {
              ref: "previewBtn",
              attrs: { type: "text" },
              on: {
                click: function ($event) {
                  _vm.isShow = true
                },
              },
            },
            [_vm._v("已配置")]
          )
        : _c(
            "el-button",
            {
              on: {
                click: function ($event) {
                  _vm.isShow = true
                },
              },
            },
            [_vm._v("打开地图")]
          ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.dialogVisible,
            "append-to-body": "",
            title: _vm.title || "地图标绘",
            width: "80%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
            close: _vm.cancel,
          },
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: !_vm.mapLoadCompleted,
                  expression: "!mapLoadCompleted",
                },
              ],
              staticClass: "content",
            },
            [
              _vm.isShowIframe
                ? _c("iframe", {
                    ref: "saasIframe",
                    attrs: {
                      src: _vm.appSaasUrl + "/baseMap",
                      frameborder: "0",
                      height: "100%",
                      width: "100%",
                    },
                  })
                : _c("el-empty", {
                    attrs: { description: "加载地图失败，请配置saas平台地址" },
                  }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "default", plain: "", size: "small" },
                  on: { click: _vm.cancel },
                },
                [_vm._v("取 消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: {
                    type: !_vm.mapLoadCompleted ? "default" : "primary",
                    plain: !_vm.mapLoadCompleted,
                    disabled: !_vm.mapLoadCompleted,
                    size: "small",
                  },
                  on: { click: _vm.submit },
                },
                [_vm._v("保 存")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }